import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { memo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import useLegacyProps from '../../hooks/useLegacyProps.js';
import ICON_NAME_MAP from '../../constants/iconNameMap.js';

var _excluded = ["children", "isDescending", "isSorted", "sortable", "theme", "hasSubHeaders"];
var _templateObject, _templateObject2;
var StyledTableHeaderCol = styled('th')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  text-align: left;\n  vertical-align: top;\n  ", "\n  ", ";\n\n  ", "\n"])), function (_ref) {
  var _ref$theme = _ref.theme,
    header = _ref$theme.table.header,
    palette = _ref$theme.palette,
    hasSubHeaders = _ref.hasSubHeaders;
  return hasSubHeaders && header !== null && header !== void 0 && header.subHeaderBackgroundColor ? "background-color: ".concat(palette[header.subHeaderBackgroundColor], " !important") : '';
}, function (_ref2) {
  var header = _ref2.theme.table.header;
  return header ? "font-weight: ".concat(header.fontWeight, ";") : '';
}, function (_ref3) {
  var sortable = _ref3.sortable;
  return sortable ? "\n    &:hover {\n      cursor: pointer;\n      text-decoration: underline;\n    };\n  " : null;
});
var StyledTableHeaderColSpan = styled('span')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  height: 100%;\n  width: 100%;\n  display: inline-block;\n  position: relative;\n  &:after {\n    content: ", ";\n    font: normal normal normal 15px/1 LfgIcons;\n    font-size: 0.75rem;\n    font-weight: bold;\n    position: absolute;\n    right: ", ";\n    top: 50%;\n    transform: translate(-50%, -50%);\n  }\n"])), function (_ref4) {
  var _theme$table, _theme$table2, _theme$table3, _theme$table4, _theme$table5, _theme$table6;
  var theme = _ref4.theme,
    hasSubHeaders = _ref4.hasSubHeaders;
  return !hasSubHeaders ? "\n    padding: ".concat((_theme$table = theme.table) === null || _theme$table === void 0 ? void 0 : _theme$table.cellPaddingTop, " ").concat((_theme$table2 = theme.table) === null || _theme$table2 === void 0 ? void 0 : _theme$table2.cellPaddingRight, " ").concat((_theme$table3 = theme.table) === null || _theme$table3 === void 0 ? void 0 : _theme$table3.cellPaddingBottom, " ").concat((_theme$table4 = theme.table) === null || _theme$table4 === void 0 ? void 0 : _theme$table4.cellPaddingLeft, "\n  ") : "\n      ".concat(theme.table.header ? "background-color: ".concat(theme.palette[theme.table.header.backgroundColor], ";") : '', "\n      div { \n  padding: calc(").concat((_theme$table5 = theme.table) !== null && _theme$table5 !== void 0 && _theme$table5.header ? theme.table.header.borderWidth : '0px', " + ").concat((_theme$table6 = theme.table) === null || _theme$table6 === void 0 ? void 0 : _theme$table6.cellPaddingBottom, ");\n  }");
}, function (_ref5) {
  var isDescending = _ref5.isDescending,
    isSorted = _ref5.isSorted;
  // This logic may seem counterintuitive to JS logic, but makes more sense to a user
  if (isSorted && isDescending) {
    return "'\\".concat(ICON_NAME_MAP['long-arrow-up-regular'], "'"); // ↑
  }
  if (isSorted && !isDescending) {
    return "'\\".concat(ICON_NAME_MAP['long-arrow-down-regular'], "'"); // ↓
  }
  return null;
}, function (_ref6) {
  var _theme$table7;
  var theme = _ref6.theme;
  return (_theme$table7 = theme.table) === null || _theme$table7 === void 0 ? void 0 : _theme$table7.cellPaddingRight;
});
var TableHeaderCol = function TableHeaderCol(_ref7) {
  var children = _ref7.children,
    isDescending = _ref7.isDescending,
    isSorted = _ref7.isSorted,
    sortable = _ref7.sortable,
    _ref7$theme = _ref7.theme,
    theme = _ref7$theme === void 0 ? themes["default"] : _ref7$theme,
    hasSubHeaders = _ref7.hasSubHeaders,
    rest = _objectWithoutProperties(_ref7, _excluded);
  var _useLegacyProps = useLegacyProps(rest),
    className = _useLegacyProps.className,
    style = _useLegacyProps.style;
  return /*#__PURE__*/React.createElement(StyledTableHeaderCol, _extends({
    sortable: sortable,
    theme: theme
  }, rest, {
    className: className,
    style: style,
    colSpan: rest.colSpan,
    rowSpan: rest.rowSpan,
    hasSubHeaders: hasSubHeaders
  }), /*#__PURE__*/React.createElement(StyledTableHeaderColSpan, {
    isDescending: isDescending,
    isSorted: isSorted,
    hasSubHeaders: hasSubHeaders,
    theme: theme
  }, children));
};
var _TableHeaderCol = withDefaultTheme(/*#__PURE__*/memo(TableHeaderCol));

export default _TableHeaderCol;
